import Link from "next/link";
import Cross from "../../../public/homePage/sidebar/cross.svg";
import { usePathname } from "next/navigation";

const Sidebar = (props: any) => {
  const { setIsSidebarOpen, isSidebarOpen } = props;
  const pathname = usePathname();

  const closeSidebar = () => {
    setIsSidebarOpen(false);
  };
  const headerUrl = [
    {
      name: "Industries",
      url: "/industries",
      suburl: [
        {
          name: "Food and Beverage",
          url: "/industries/food-and-beverage",
        },
        {
          name: "Consumer Goods",
          url: "/industries/consumer-goods",
        },
        {
          name: "Healthcare",
          url: "/industries/healthcare",
        },
        {
          name: "Financial Services",
          url: "/industries/financial-services",
        },
        {
          name: "Technology",
          url: "/industries/technology",
        },
        {
          name: "Entertainment",
          url: "/industries/entertainment",
        },
        {
          name: "Sports",
          url: "/industries/sports",
        },
        {
          name: "Advertising",
          url: "/industries/advertising",
        },
      ],
    },
    {
      name: "Services",
      url: "/services",
      suburl: {
        Research: [
          {
            name: "Product Insights",
            url: "/services/product-insights",
            subUrls: [
              {
                name: "Features testing",
                url: "/services/product-insights",
              },
              {
                name: "Barrier to adoption",
                url: "/services/product-insights",
              },
              {
                name: "Improvement needed",
                url: "/services/product-insights",
              },
              {
                name: "Packaging Research",
                url: "/services/product-insights",
              },
              {
                name: "Pricing Research",
                url: "/services/product-insights",
              },
            ],
          },
          {
            name: "Brand Research",
            url: "/services/brand-research",
            subUrls: [
              {
                name: "Brand Awareness Research",
                url: "/services/brand-research",
              },
              {
                name: "Brand Tracking Research",
                url: "/services/brand-research",
              },
              {
                name: "Campaign Evaluation",
                url: "/services/brand-research",
              },
              {
                name: "Brand Communication",
                url: "/services/brand-research",
              },
              {
                name: "Brand",
                url: "/services/brand-research",
              },
            ],
          },
          {
            name: "New Product Development",
            url: "/services/product-development",
            subUrls: [
              {
                name: "Idea Screening",
                url: "/services/product-development",
              },
              {
                name: "Concept Testing and Validation",
                url: "/services/product-development",
              },
              {
                name: "Product testing",
                url: "/services/product-development",
              },
              {
                name: "Pricing Research",
                url: "/services/product-development",
              },
            ],
          },
          {
            name: "Consumer Research",
            url: "/services/consumer-research",
            subUrls: [
              {
                name: "Consumer Usage and Attitude",
                url: "/services/consumer-research",
              },
              {
                name: "Consumer Segmentation",
                url: "/services/consumer-research",
              },
              {
                name: "Customer satisfaction and NPS Measurement",
                url: "/services/consumer-research",
              },
            ],
          },
          {
            name: "Marketing Assessment",
            url: "/services/market-assessment",
            subUrls: [
              {
                name: "Demand and Forecasting",
                url: "/services/market-assessment",
              },
              {
                name: "Demand Research",
                url: "/services/market-assessment",
              },
              {
                name: "Competition Analysis",
                url: "/services/market-assessment",
              },
            ],
          },
          {
            name: "Sensory Research",
            url: "/services/sensory-research",
            subUrls: [
              {
                name: "Central location testing",
                url: "/services/sensory-research",
              },
              {
                name: "Home User testing",
                url: "/services/sensory-research",
              },
              {
                name: "Food experts",
                url: "/services/sensory-research",
              },
            ],
          },
        ],
        DataCollection: [
          {
            name: "Mystery Shopping",
            url: "/services/mystery-shopping",
            subUrls: [
              {
                name: "Store Performance Audits",
                url: "/services/mystery-shopping",
              },
              {
                name: "Competition Benchmarking checks",
                url: "/services/mystery-shopping",
              },
              {
                name: "Store Process Evaluations",
                url: "/services/mystery-shopping",
              },
              {
                name: "Customer Interaction Feedback",
                url: "/services/mystery-shopping",
              },
            ],
          },

          {
            name: "Advanced Analytics",
            url: "/services/advanced-analytics/statistical-testing",
            subUrls: [
              {
                name: "Statistical & Hypothesis Testing",
                url: "/services/advanced-analytics/statistical-testing",
              },
              {
                name: "Regression (Key Driver)",
                url: "/services/advanced-analytics/regression",
              },
              {
                name: "Customer Segmentation",
                url: "/services/advanced-analytics/customer-segment",
              },
              {
                name: "Choice Models",
                url: "/services/advanced-analytics/choice-models",
              },
              {
                name: "Clustering Analysis",
                url: "/services/advanced-analytics/cluster-analysis",
              },
              {
                name: "Principal Component & Factor Analysis",
                url: "/services/advanced-analytics/principal-component",
              },
              {
                name: "Perceptual Maps",
                url: "/services/advanced-analytics/perceptual-maps",
              },
            ],
          },
          {
            name: "Data Collection & Analysis",
            url: "/data-collection-and-analysis/survey-scripting",
            subUrls: [
              {
                name: "Survey Scripting",
                url: "/data-collection-and-analysis/survey-scripting",
              },
              {
                name: "Data Processing & Analysis",
                url: "/data-collection-and-analysis/data-processing-and-analysis",
              },
              {
                name: "Online Data Collection",
                url: "/data-collection-and-analysis/online-data-collection",
              },
              {
                name: "Data Visualization & Dashboards",
                url: "/data-collection-and-analysis/data-visualization-dashboards",
              },
              {
                name: "Community Management",
                url: "/data-collection-and-analysis/community-management",
              },
            ],
          },
        ],
      },
    },
    {
      name: "Solutions",
      url: "/solutions",
      suburl: {
        SolutionResearch: [
          {
            name: "Quantis ",
            url: "/solutions/quantis/retail",
            subUrls: [
              {
                name: "Retail",
                url: "/solutions/quantis/retail",
              },
              {
                name: "QSR Franchisee",
                url: "/solutions/quantis/qsr-franchisee",
              },
              {
                name: "Fragrance",
                url: "/solutions/quantis/fragrance-industry",
              },
              {
                name: "Optical",
                url: "/solutions/quantis/optical-industry",
              },
              {
                name: "Fashion",
                url: "/solutions/quantis/fashion-industry",
              },
            ],
          },
          {
            name: "InterceptIQ",
            url: "/solutions/interceptiQ",
            subUrls: [],
          },
        ],
      },
    },
    {
      name: "Products",
      url: "/products",
      suburl: [
        {
          name: "AI in Market Research",
          url: "/products/AI/probemeai",
        },
        {
          name: "Raven",
          url: "/products/raven",
        },
        {
          name: "TabGen",
          url: "/products/tabgen",
        },
        {
          name: "Data Validator",
          url: "/products/data-validator",
        },
        {
          name: "SLM",
          url: "/products/slm",
        },
        {
          name: "Gamification",
          url: "/products/gamification",
        },
        {
          name: "Inscribee",
          url: "/products/inscribee",
        },
      ],
    },
    {
      name: "About",
      url: "/about",
    },
    {
      name: "Careers",
      url: "/careers",
    },
    {
      name: "Contact",
      url: "/contact",
    },
    {
      name: "Policies",
      url: "/policies",
    },

    ,
  ];

  const handleClick = () => {
    setTimeout(() => {
      setIsSidebarOpen(false);
    }, 500);
  };

  return (
    <>
      <div
        className={`sidebar-overlay ${
          isSidebarOpen ? "sidebar-overlay-show" : ""
        }`}
        onClick={closeSidebar}></div>
      <div
        className={`side-bar-container ${isSidebarOpen ? "show-sidebar" : ""}`}>
        <div className="side-bar-container__heading px-4 px-md-5 py-4">
          <Cross onClick={closeSidebar} />
        </div>
        <ul className="items">
          {headerUrl?.map((header: any, index: number) => {
            const serverData =
              header?.name != "Services" && header?.name != "Solutions";

            return (
              <li
                className={`${
                  serverData ? "sidebar-industries" : "sidebar-service"
                } ripple-bullet item ${
                  !isSidebarOpen ? "pointer-decibel" : ""
                }`}
                key={index}>
                {header?.suburl ? (
                  <Link
                    href={header.url}
                    className="header-url"
                    onClick={() => handleClick()}>
                    <div
                      className={
                        header?.suburl
                          ? "bullet-text-wraper bullet-check"
                          : "bullet-text-wraper bullet-check default-url"
                      }>
                      <span></span>
                      {header.name}
                    </div>
                  </Link>
                ) : (
                  <Link
                    href={header.url}
                    className="header-url"
                    onClick={() => handleClick()}>
                    <div
                      className={
                        header?.suburl
                          ? "bullet-text-wraper bullet-check"
                          : "bullet-text-wraper bullet-check default-url"
                      }>
                      <span></span>
                      {header.name}
                    </div>
                  </Link>
                )}
                {header?.name != "Services" && header?.name != "Solutions" ? (
                  <div
                    className={`${
                      header?.suburl
                        ? "sidebar-industries-sub  sidebar-sub-item"
                        : ""
                    } `}>
                    {header?.name === "Products" && (
                      <h4 className="text-black">{header?.name}</h4>
                    )}
                    {header?.name === "Industries" && (
                      <h4 className="text-black">{header?.name}</h4>
                    )}
                    <ul key={index}>
                      {header?.suburl?.length > 0 &&
                        header?.suburl?.map((urls: any, index: number) => {
                          return (
                            <li
                              className={`ripple-bullet mobile-riple ${
                                pathname === urls?.url ? "active-url" : ""
                              } `}
                              key={index}>
                              <Link
                                className=""
                                href={urls?.url}
                                onClick={() => handleClick()}>
                                <div className="bullet-text-wraper-inner">
                                  <span></span>
                                  {urls?.name}{" "}
                                </div>
                              </Link>
                            </li>
                          );
                        })}
                    </ul>
                  </div>
                ) : (
                  <div
                    className={`container-fluid ${header?.name === "Solutions" ? "sidebar-service-sub-solution sidebar-sub-item_solution" : "sidebar-service-sub sidebar-sub-item  research-sec"}`}>
                    <div className="row">
                      <div
                        className={`col-12  ${header?.name === "Solutions" ? "text-black" : "row-sec"}`}>
                        <h4>
                          {header?.name === "Solutions"
                            ? "Solutions"
                            : "Research & Services"}
                        </h4>
                      </div>
                    </div>
                    <div className="row">
                      {header?.suburl.Research?.map(
                        (research: any, index: number) => {
                          return (
                            <div
                              className=" col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4 mb-3"
                              key={index}>
                              {/* <h2>{research?.name}</h2> */}
                              <Link
                                href={research?.url}
                                className={`data-url hover-line-effect ${
                                  pathname === research?.url ? "active-url" : ""
                                }`}
                                onClick={() => handleClick()}>
                                {research?.name}
                              </Link>
                              <ul key={index}>
                                {research?.subUrls?.map(
                                  (subUrl: any, index: number) => {
                                    return (
                                      <li
                                        className={`sub-ripple-bullet`}
                                        key={index}>
                                        <Link
                                          href={subUrl?.url}
                                          onClick={() => handleClick()}>
                                          <div className="bullet-text-wraper-inner">
                                            <span></span>
                                            {subUrl?.name}
                                          </div>
                                        </Link>
                                      </li>
                                    );
                                  },
                                )}
                              </ul>
                            </div>
                          );
                        },
                      )}
                      {header?.suburl.SolutionResearch?.map(
                        (research: any, index: number) => {
                          return (
                            <div className="mt-2" key={index}>
                              {/* <h2>{research?.name}</h2> */}
                              <Link
                                href={research?.url}
                                className={`data-url hover-line-effect ${
                                  pathname === research?.url ? "active-url" : ""
                                }`}
                                onClick={() => handleClick()}>
                                {research?.name}
                              </Link>
                              <ul key={index}>
                                {research?.subUrls?.map(
                                  (subUrl: any, index: number) => {
                                    return (
                                      <li
                                        className={`sub-ripple-bullet`}
                                        key={index}>
                                        <Link
                                          href={subUrl?.url}
                                          onClick={() => handleClick()}>
                                          <div className="bullet-text-wraper-inner">
                                            <span></span>
                                            {subUrl?.name}
                                          </div>
                                        </Link>
                                      </li>
                                    );
                                  },
                                )}
                              </ul>
                            </div>
                          );
                        },
                      )}
                    </div>

                    <div className="border-top_ row py-4_5__">
                      <ul key={index}>
                        <div className="row">
                          {header?.suburl.DataCollection?.map(
                            (research: any, index: number) => {
                              return (
                                <div
                                  className=" col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4 mb-3 mobile-margin-top"
                                  key={index}>
                                  {/* <h2></h2> */}
                                  <Link
                                    href={research?.url}
                                    className="data-url hover-line-effect"
                                    onClick={() => handleClick()}>
                                    {research?.name}
                                  </Link>
                                  <ul key={index}>
                                    {research?.subUrls?.map(
                                      (subUrl: any, index: number) => {
                                        return (
                                          <li
                                            className={`sub-ripple-bullet ${
                                              pathname === subUrl?.url
                                                ? "active-url"
                                                : ""
                                            }`}
                                            key={index}>
                                            <Link
                                              href={subUrl?.url}
                                              onClick={() => handleClick()}>
                                              <div className="bullet-text-wraper-inner">
                                                <span></span>
                                                {subUrl?.name}
                                              </div>
                                            </Link>
                                          </li>
                                        );
                                      },
                                    )}
                                  </ul>
                                </div>
                              );
                            },
                          )}
                        </div>
                      </ul>
                    </div>
                  </div>
                )}
              </li>
            );
          })}
        </ul>
      </div>
    </>
  );
};

export default Sidebar;
